module.exports = __webpack_public_path__ + "media/assets/illustrations/demographic-survey-3ea3731cadc75ecb209c747927bb88bf.png";